import request from 'superagent'
import { WORK_URL } from '../config/environments'
import Bluebird from 'bluebird'

export type TVoucherType =
  | 'OPENING_20_PERCENT'
  | 'STAFF_DISCOUNT'
  | 'AMOUNT'
  | 'NONE'
  | 'DISCOUNT_CAKE_ORDER_BIG'
  | 'DISCOUNT_CAKE_ORDER_NORMAL'
  | 'DISCOUNT_CAKE_ORDER'
  | 'DISCOUNT_CAKE_ORDER_10_PERCENT'
  | 'DISCOUNT_BREAD_ORDER_BY_PERCENT'
  | 'DISCOUNT_CAKE_TET_ORDER_BY_PERCENT'
  | 'DISCOUNT_CAKE_BY_PRODUCT'
  | 'DISCOUNT_CAKE_BY_PRODUCT_CAT'
  | 'VOUCHER_50K'
  // baemin
  | 'HANOIPA1'
  | 'HANOIPA2'
  | 'HANOIPA3'
  | 'HANOIPA4'
  | 'HANOIPA5'
  | 'HANOIPA6'
  | 'HANOIPA7'
  | 'HANOIPA8'
  // Befood
  | 'BE150'
  | 'BE250'
  | 'BE200'
  | 'BE500'
  // GOJEK
  | 'CART_OFF_50K'
  | 'CART_OFF_65K'
  | 'CART_OFF_85K'
  | 'CART_OFF_100K'
  | 'CART_OFF_120K'
  | 'CART_OFF_150K'
  | 'CART_OFF_170K'
  // GRAB
  | 'BOSS20'
  | 'BOSS30B'
  | 'BOSS40'
  | 'BOSS50'
  | 'BOSS70'
  // shopeefood
  | 'SIEUTIEC10'
  | 'SIEUTIEC20'
  | 'SIEUTIEC30'
  | 'SIEUTIEC40'
  | 'SIEUTIEC50'
  | 'SIEUTIEC50K'
  | 'SIEUTIEC70'
  | 'SIEUTIEC99'
  | 'SIEUTIEC30K'
  | 'SIEUTIEC40K'
  | 'SIEUTIEC35K'
  | 'SIEUTIEC45K'
  | 'SIEUTIEC75K'
  | 'SIEUTIEC109K'
  | 'SIEUTIEC139K'
  | 'SIEUTIEC199K'
  | '1111SIEUDEAL45'
  | '1111SIEUDEAL35'
  | '1111SIEUDEAL110'

interface IOutletRef {
  _id?: string
  code?: string
  name?: string
}

export interface IVoucher {
  _id: string
  name: string
  couponCode?: string
  voucherType: TVoucherType
  amount: number
  quantity?: number
  withoutCard?: boolean
  // outlets can be array of ObjectIds, outlet codes, or outlet objects
  outlets?: Array<string | IOutletRef>
  saleProducts?: Array<{
    product?: string
    sku?: string
    description?: string
    discountPrice?: number
  }>
  saleProductCats?: Array<{
    productCat?: string
    name?: string
  }>
  minValueOrder?: number
  startDate?: Date
  expiryDate?: Date
}

export interface ICustomer {
  _id: string
  fullName: string
  cellphone: string
  customerId: string
  searchCustomerType?: string
  numRemainDiscount?: number
  remainDiscountValue?: number
  customerPoints?: number
  isStaff?: boolean
  vouchers?: IVoucher[]
  birthday?: Date
  address?: {
    district?: string
    street?: string
    city?: string
  }
  registered?: boolean
  registerTime?: Date
  drinkSkus?: []
  mooncakeSkus?: []
  mooncakePercent?: number
  numRemainMooncakeDiscount?: number
  tetCakeCandySkus?: []
  tetCakeCandyProducts?: []
  tetCakeCandyPercent?: number
  tetCakeCandyMaxDiscountTotal?: number
  boughtSavorStoreSalesMap?: {}
  tinBoxFireworkGiftedOnlineOrder?: string
  tinBoxFireworkSold?: boolean
  discountStaffSavorBread?: boolean
  discountStaffSavorCake?: boolean
  numSaleBread?: number
  numSaleCake?: number
  numGiftedNationalDayCake?: number
  scakePremiumCutleryGiftResult?: {
    ordersInPreviousMonth: number // Số đơn tháng -1
    ordersInTwoMonthsAgo: number // Số đơn tháng -2
    isEligible: boolean // Đủ điều kiện hay không
    month1Period: string // Tháng -1
    month2Period: string // Tháng -2
  }
  mooncakeDiscountWithBirthdayCakeResult?: any
}

export class CustomerStore {
  searchCustomer = (searchText: string) => {
    return Bluebird.resolve(
      request
        .get(WORK_URL + '/api/customers/search')
        .query({
          searchText
        })
        .then(response => response.body)
    )
  }
  searchVoucher = (couponCode: string, orderOutlet?: string) => {
    return Bluebird.resolve(
      request
        .get(`${WORK_URL}/savor_api/vouchers/search`)
        .query({
          couponCode,
          orderOutlet
        })
        .then(response => response.body)
    )
  }

  createCustomer = (customer: ICustomer) => {
    return Bluebird.resolve(
      request
        .post(`${WORK_URL}/api/customers`)
        .send(customer)
        .then(response => response.body)
    )
  }

  updateCustomer = (customer: ICustomer) => {
    return request
      .put(`${WORK_URL}/api_savor/customers/${customer._id}`)
      .send(customer)
      .then(response => response.body as ICustomer)
  }
}

export const customerStore = new CustomerStore()
